import { SmallTherapist } from 'domains/calendars/types';
import { SlotAvailability } from 'domains/calendars/v3/useEvaluationCalendarSummary';
import { createContext } from 'react';

type SplitEvaluationContextTypeV2 = {
  onSubmitFirstSlot: (timeSlot: SlotAvailability) => void;
  onSubmitSecondSlot: (timeSlot: SlotAvailability) => void;
  onSkipSecondSlot: () => void;
  onSubmitTherapist: (therapist: SmallTherapist) => void;

  commonTherapists?: SmallTherapist[];
  firstTimeSlot?: SlotAvailability;
  secondTimeSlot?: SlotAvailability;
};

export const SplitEvaluationContextV2 = createContext<null | SplitEvaluationContextTypeV2>(null);
